import React from "react";
import AboutPlacementSection from "../../Sections/AboutPlacementSection/Content";
const AboutPlacementPage = () => {
  return <AboutPlacementSection />;
};
export default AboutPlacementPage;
